import { render, staticRenderFns } from "./NewTasksKiko.vue?vue&type=template&id=ee6f0dda&scoped=true"
import script from "./NewTasksKiko.vue?vue&type=script&lang=js"
export * from "./NewTasksKiko.vue?vue&type=script&lang=js"
import style0 from "./NewTasksKiko.vue?vue&type=style&index=0&id=ee6f0dda&prod&lang=less&scoped=true"
import style1 from "./NewTasksKiko.vue?vue&type=style&index=1&id=ee6f0dda&prod&lang=less&scoped=true"
import style2 from "./NewTasksKiko.vue?vue&type=style&index=2&id=ee6f0dda&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ee6f0dda",
  null
  
)

export default component.exports